import React, { createContext, createRef, useContext } from 'react';
import Input from '../components/utils/Input';
import Editor from "jodit-react";
import { useData } from './DataContext';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputAdornment from '@material-ui/core/InputAdornment';
import DragFile from '../components/utils/DragFile';
import { Typography } from '@material-ui/core';
const FunctionsContext = createContext();

export const useFunctions = ()=> useContext(FunctionsContext);

const FunctionsContextProvider = ({children}) => {
  const { tags } = useData()
  class Refs {
    constructor(values=[],tags=[]) {
      values.forEach((el) => {
        this[el] = {
          ref: createRef(),
          placeholder: el
        };
      });
      tags.forEach((el) => {
        this[el.name] = {
          ref: createRef(),
          placeholder:  el.name,
          ...el
        };
      });
      
    }
  }
  const allInputs = {
    terms: {
      inputs: [{name:"heading"}],
      editors: ["description"]
    },
    faq: {
      inputs: [{name:"question"}],
      editors: ["answer"]
    },
    // about_link: {
    //   inputs: [
    //     {name: "heading_first"},
    //     {name: "heading_second"},
    //     {name: "heading_third"},
    //     {name: "subheading"},
    //   ],
    //   images: [
    //     {name: "photo_1",type: "video/*"}
    //   ]
    // },
    payments:{
      inputs: [
        {name: "name"},
        {name: "mobile_number"},
        {name: "name_of_influencer"},
        {name: "date_time_of_event"},
      ],
    },
    about_link: {
      inputs: [
        // {name: "heading"},
        {name: "link",type: {name: `url`}},
        {name: "link_text"},
      ],
      // editors: ["details"],
      // images: [
      //   {name: "photo_1"}
      // ]
    },
    social_icon_1:{
      images: [{name:"icon"}],
      inputs: [{name: "icon_name"},{name: "link",type: {name: `url`}},]
    },
    social_icon_2:{
      images: [{name:"icon"}],
      inputs: [{name: "icon_name"},{name: "link",type: {name: `url`}},]
    },
    social_icon_3:{
      images: [{name:"icon"}],
      inputs: [{name: "icon_name"},{name: "link",type: {name: `url`}},]
    },
    social_icon_4:{
      images: [{name:"icon"}],
      inputs: [{name: "icon_name"},{name: "link",type: {name: `url`}},]
    },
    social_icon_5:{
      images: [{name:"icon"}],
      inputs: [{name: "icon_name"},{name: "link",type: {name: `url`}},]
    },
    website_details: {
      inputs: [
        {name: "website_name"},
        // {name: "email",type: {name: `email`}},
        // {name: "phone_no"},
        // {name: "slogan"},
      ],
      // editors: [
      //   "description"
      // ],
      images: [
        {name: "favicon"},
        {name: "logo"}
      ]
    },
    // about_section_3: {
    //   inputs: [
    //     {name: "heading"},
    //     {name: "link",type: {name: `url`}},
    //     {name: "link_text"},
    //   ],
    //   editors: ["details"],
    //   images: [
    //     {name: "photo_1"},
    //     {name: "photo_2"}
    //   ]
    // },
    // about_section_4: {
    //   inputs: [
    //     {name: "heading"},
    //     {name: "subheading"},
    //     {name: "icon_heading_1"},
    //     {name: "icon_heading_2"},
    //     {name: "icon_heading_3"},
    //     {name: "paragraph_1"},
    //     {name: "paragraph_2"},
    //     {name: "paragraph_3"},
    //   ],
    //   images: [
    //     {name: "photo_1"}
    //   ]
    // },
    payment_checkboxes: {
      editors: ["term"]
    },
    persons: {
      inputs: [
        {name:"name"},
        {name:"price"},
        {name:"website",type: {name: `url`}},
      ],
      editors: ["description"],
      tags,
      images: [{name:"photos",type: `image/*, video/*`,size: 5}]
    },
    tags: {
      inputs: [{name:"name"}],
      selects: [{
        name: "type",
        options: ['text','number','date','time'],
        units: ['$',"kg","seconds","cm"]
      }]
    },
    about_banners: {
      images: [{name:"photos",type: `image/*, video/*`}]
    },
    thank_you_banners: {
      images: [{name:"photos",type: `image/*, video/*`}]
    },
    join_us_banners: {
      images: [{name:"photos",type: `image/*, video/*`}],
    },
    join_us_link:{
      inputs: [{name: "link",type: {name: `url`}},{name: "link_text"},]
    }
  }
  class GetValues {
    constructor(values = {}) {
      Object.entries(values).forEach((el) => {
        this[el[0]] = `${el[1].ref.current.value}${el[1]?.type?.unit||``}`;
      });
    }
  }

  const showEditors = (editorRefs={},active) =>
    Object.entries(editorRefs)?.map((el, i) => (
      <div key={i} className="col-12 py-2">
        <p style={{ textTransform: `uppercase` }}>
          {el[1].placeholder.split("_").join(" ")}:
        </p>
        <Editor
          ref={el[1].ref}
          required
          value={active[el[0]]}
          config={{
            editorCssClass: el[0],
            placeholder: el[1].placeholder.split("_").join(" "),
          }}
        />
      </div>
    ));
  const showTags = (tagRefs={},active,required=true) =>
    Object.entries(tagRefs)?.map((el, i) => (
      <div key={i} className={"col-lg-6"}>
        <label htmlFor={el[1].placeholder} className="text-capitalize fw-bolder"> {el[1].placeholder.split("_").join(" ")} </label>
        <Input
          ref={el[1].ref}
          required={required}
          id={el[1].placeholder}
          defaultValue={active[el[0]]}
          placeholder={el[1].placeholder.split("_").join(" ")}
          type={el[1]?.type?.name}
          step=".01"
          InputProps={{endAdornment: <InputAdornment className="text-capitalize fw-bolder" position="end">{el[1]?.type?.unit}</InputAdornment>}}
        />
      </div>
    ));
  const showImages = (images=[],setImages=()=>{},active={},docRef) =>
    images.map((el, i) => (
      <div key={i} className={"col-lg-6"}>
        <Typography variant="h6" className="text-capitalize fw-bold mt-3"> {el.name.split("_").join(" ")} </Typography>
        <DragFile size={el.size} type={el.type} docRef={docRef} name={el.name} active={active[el.name]?.map((preview,i)=>({...preview,database: true,i}))} setImages={(images)=> setImages(prev=>({...prev,[el.name]: images}))} />
      </div>
    ));
  const showSelect = (selects=[],selectValues,setSelects) =>
    selects.map((el, i) => (
      <div key={i} className="col-lg-6">
        <label htmlFor={el.name} className="text-capitalize fw-bolder"> {el.name.split("_").join(" ")} </label>
        <div className="field">
          <Select displayEmpty required
            id={el.name}
            className="field_input text-capitalize"
            value={selectValues[el.name]?.name || ""}
            onChange={e=> setSelects(n=> ({...n,[el.name]: {name: e.target.value}}))}
          >
            <MenuItem disabled value="">
              <em className="text-capitalize">{el.name.split("_").join(" ")}</em>
            </MenuItem>
            {
              el.options.map(el=><MenuItem className="text-capitalize" value={el}> {el} </MenuItem>)
            }
          </Select>
        </div>
        <div className="w-100"/>
        {selectValues[el.name]?.name=== "number"&&<div className="field">
          <Select displayEmpty required
            className="field_input text-capitalize"
            value={selectValues[el.name].unit || ""}
            onChange={e=> setSelects(n=> ({...n,[el.name]: {...n[el.name],unit: e.target.value}}))}
          >
            <MenuItem disabled value="">
              <em className="text-capitalize">Unit</em>
            </MenuItem>
            {
              el.units.map(el=><MenuItem className="text-capitalize" value={el}> {el} </MenuItem>)
            }
          </Select>
        </div>}
      </div>
    ));
  const value = {Refs,GetValues,showImages,showTags,showSelect,allInputs,showEditors}
  return (
    <FunctionsContext.Provider {...{value}}>
      {children}
    </FunctionsContext.Provider>
  );
};

export default FunctionsContextProvider;